import {
  IListElementCell,
  isLinkCell,
} from 'app/services/api5-service/api.interface';

import { ISPFormState } from 'common/dynamic-form/model';
import { DocHelper } from 'utils/dochelper';

import { IListCellUi } from '../../list-cell/model';

/**
 * Get link cell with specific data
 *
 * @param cell - FE cell base metadata
 * @param state
 * @param cellData - BE data of cell
 */
export function getLinkCellWithData(
  cell: IListCellUi,
  state: ISPFormState,
  cellData: IListElementCell,
): IListCellUi {
  if (!isLinkCell(cellData)) {
    return cell;
  }

  cell.linkData = {
    internal: cellData.$internal === 'yes',
    newTab: cellData.$newtab === 'yes',
    sameTab: cellData.$sametab === 'yes',
    href: cellData.$,
    target: cellData.$target,
    img: {
      icon: cellData.$icon,
    },
    imgPlace: cellData.$icon_side,
    caption: DocHelper.getMessage(cellData.$name, state.docSubject.value),
  } as IListCellUi['linkData'];
  return cell;
}
